var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "quotation-kpi" }, [
    _c("div", { staticClass: "header row" }, [
      _c("div", { staticClass: "column small-6 medium-6 large-6" }, [
        _c("p", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("company.performance.quotationKPI"))),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "item-title" }, [
          _vm._v(_vm._s(_vm.$t("company.performance.nonTender")) + ":"),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "percent" }, [
          _vm._v(_vm._s(_vm.nonCompetitiveCount)),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "detail-item column small-6 medium-6 large-6" },
        [
          _c("div", { staticClass: "item-title" }, [
            _vm._v(
              _vm._s(_vm.$t("company.performance.accumulatedPoAmount")) + ":"
            ),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("span", { staticClass: "percent po-amount" }, [
              _vm._v(
                _vm._s(
                  _vm._f("formatCurrency")(_vm.POAmount, { withSpace: true })
                )
              ),
            ]),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "contant" }, [
      _c(
        "div",
        { staticClass: "conditions-group" },
        _vm._l(_vm.conditions, function (item) {
          return _c("div", { key: item.label, staticClass: "condition" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.chooseConditions,
                  expression: "chooseConditions",
                },
              ],
              attrs: { type: "checkbox" },
              domProps: {
                value: item.value,
                checked: Array.isArray(_vm.chooseConditions)
                  ? _vm._i(_vm.chooseConditions, item.value) > -1
                  : _vm.chooseConditions,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.chooseConditions,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = item.value,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.chooseConditions = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.chooseConditions = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.chooseConditions = $$c
                  }
                },
              },
            }),
            _vm._v(" "),
            _c("label", [_vm._v(_vm._s(item.label))]),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "chart-detail" }, [
        _c("div", { staticClass: "center-digital" }, [
          _c("div", { staticClass: "digital" }, [
            _vm._v(_vm._s(_vm.totalInvited)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.$t("company.performance.invitations"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "chart-contant" }, [
          _c("div", { attrs: { id: "KPI-chart" } }),
          _vm._v(" "),
          _c("div", { staticClass: "digital" }, [
            _c("div", [
              _c("i", { staticClass: "quotedDot" }),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("company.performance.quoted"))),
              ]),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.totalQuotePercent + "%  [" + _vm.totalQuote + "]")
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("i", { staticClass: "declinedDot" }),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("company.performance.declined"))),
              ]),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.totalDeclinedPercent + "%  [" + _vm.totalDeclined + "]"
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("i", { staticClass: "noshowDot" }),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("company.performance.noShow"))),
              ]),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.totalNoShowPercent + "%  [" + _vm.totalNoShow + "]"
                  )
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "detail" }, [
          _c("div", { staticClass: "competitive" }, [
            _c("div", { staticClass: "detail-item" }, [
              _c("span", { staticClass: "title" }, [
                _vm._v(
                  _vm._s(_vm.$t("company.performance.tenderQwarded")) + ":"
                ),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "percent" }, [
                _vm._v(_vm._s(_vm.formatQUotation(_vm.totalAwarded))),
              ]),
              _c("span", [
                _vm._v("["),
                _c("i", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("xxOfxx", [
                        _vm.totalAwarded,
                        _vm.invitationDivided,
                      ])
                    )
                  ),
                ]),
                _vm._v("]"),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-item" }, [
              _c("span", { staticClass: "title" }, [
                _vm._v(
                  _vm._s(_vm.$t("company.performance.differenceToAwarded")) +
                    ":"
                ),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "percent" }, [
                _vm._v(_vm._s(_vm.differenceToAwarded)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-item" }, [
              _c("span", { staticClass: "title" }, [
                _vm._v(
                  _vm._s(_vm.$t("company.performance.highestQuotation")) + ":"
                ),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "percent" }, [
                _vm._v(_vm._s(_vm.formatQUotation(_vm.highestQuotation))),
              ]),
              _c("span", [
                _vm._v(" ["),
                _c("i", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("xxOfxx", [
                        _vm.highestQuotation,
                        _vm.invitationDivided,
                      ])
                    )
                  ),
                ]),
                _vm._v("]"),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }